<template>
  <vs-tabs v-model="activeTab" :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">
    <!-- GENERAL -->
    <vs-tab :disabled="false" icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'General' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <supplier-manufacturing-home v-on:notify="notify($event)"/>
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-user-check" :label="!isSmallerScreen ? 'Employee Details' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <supplier-manufacturing-employee v-on:notify="notify($event)"/>
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-grid" :label="!isSmallerScreen ? 'Site Details' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <supplier-manufacturing-site-details v-on:notify="notify($event)"/>
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-check" :label="!isSmallerScreen ? 'Quality Management System' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <supplier-manufacturing-quality v-on:notify="notify($event)" />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-cloud-drizzle" :label="!isSmallerScreen ? 'Environmental' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <supplier-manufacturing-environment v-on:notify="notify($event)"/>
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-check-square" :label="!isSmallerScreen ? 'Ethical' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
       <supplier-manufacturing-ethical v-on:notify="notify($event)"/>
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-shield-off" :label="!isSmallerScreen ? 'Allergens' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <supplier-manufacturing-allergens v-on:notify="notify($event)"/>
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'HACCP' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <supplier-manufacturing-haccp v-on:notify="notify($event)"/>
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-circle" :label="!isSmallerScreen ? 'Hygiene' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
       <supplier-manufacturing-hygiene v-on:notify="notify($event)"/>
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-triangle" :label="!isSmallerScreen ? 'Pest Control' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <supplier-manufacturing-pest v-on:notify="notify($event)"/>
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-package" :label="!isSmallerScreen ? 'Transport & Storage' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <supplier-manufacturing-transport v-on:notify="notify($event)"/>
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-shield" :label="!isSmallerScreen ? 'Health & Safety' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <supplier-manufacturing-health-safety v-on:notify="notify($event)"/>
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-star" :label="!isSmallerScreen ? 'Product Authenticity & Traceability' : ''">
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <supplier-manufacturing-authenticity/>
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  const SupplierRepository = RepositoryFactory.get('supplier');

  import SupplierManufacturingHome from './SupplierManufacturingHome.vue'
  import SupplierManufacturingEmployee from './SupplierManufacturingEmployee.vue'
  import SupplierManufacturingSiteDetails from './SupplierManufacturingSiteDetails.vue'
  import SupplierManufacturingQuality from './SupplierManufacturingQuility.vue'
  import SupplierManufacturingEnvironment from './SupplierManufacturingEnvironment.vue'
  import SupplierManufacturingEthical from './SupplierManufacturingEthical.vue'
  import SupplierManufacturingAllergens from './SupplierManufacturingAllergens.vue'
  import SupplierManufacturingHaccp from './SupplierManufacturingHaccp.vue'
  import SupplierManufacturingPest from './SupplierManufacturingPest.vue'
  import SupplierManufacturingTransport from './SupplierManufacturingTransport.vue'
  import SupplierManufacturingHealthSafety from './SupplierManufacturingHealthSafety.vue'
  import SupplierManufacturingAuthenticity from './SupplierManufacturingAuthenticity.vue'
  import SupplierManufacturingHygiene from './SupplierManufacturingHygiene.vue'

  import supplierRepository from "../../../../repository/supplierRepository";


  export default {
    components: {
      SupplierManufacturingHome,
      SupplierManufacturingEmployee,
      SupplierManufacturingSiteDetails,
      SupplierManufacturingQuality,
      SupplierManufacturingEnvironment,
      SupplierManufacturingEthical,
      SupplierManufacturingAllergens,
      SupplierManufacturingHaccp,
      SupplierManufacturingPest,
      SupplierManufacturingTransport,
      SupplierManufacturingHealthSafety,
      SupplierManufacturingAuthenticity,
      SupplierManufacturingHygiene
    },
    data () {
      return {
        activeTab: 0,
        id: null,
        status: {},
        index: null
      }
    },
    methods: {
      notify() {
        this.activeTab++
      },
      async checkStepFactory() {
        return Object.entries(this.status).forEach(([key, value], index) => {
          if (value === 0) {
            console.log(index)
            return index--
          }
        });
      }
    },
    async mounted() {
      this.id = this.$route.params.id
      const {data} = (await supplierRepository.getManufactureSiteStatus(this.id)).data
      this.status = data
      console.log(this.status)
      // const index = await this.checkStepFactory()
      // console.log(index)
    },
    computed: {
      isSmallerScreen () {
        return this.$store.state.windowWidth < 768
      }
    }
  }
</script>

<style lang="scss">
  #profile-tabs {
    .vs-tabs--content {
      padding: 0;
    }
  }
</style>
